//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('selectNewDoctype', {
//        templateUrl: 'views/components/views/selectNewDoctype/selectNewDoctype.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'selectNewDoctypeService', function ($stateParams, selectNewDoctypeService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let argType = $stateParams.argtype;
//            let argValue = $stateParams.argvalue;
            
//            vm.model = {
//                itemsListDocarcTypes: []
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION

//            async function loadDocarcTypes() {
//                vm.model.itemsListDocarcTypes = await selectNewDoctypeService.listDocarcTypes({
//                    argtype: argType,
//                    argvalue: argValue
//                });
//            }

//            // #endregion LOAD PROCEDURE FUNCTION

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                loadDocarcTypes();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
